export default __webpack_public_path__ + "static/media/duck2_thumb.5493fbb1.jpg";